export default "__VITE_ASSET__Di_Q9Hx4__"